export enum AgreementKey {
  NON_DIAGNOSTIC = 'nonDiagnostic',
}

export type Agreement = {
  id: number;
  tinyaccount_id: string;
  agreement_key: AgreementKey;
  agreed_at: string;
  kit_id: string | null;
  created_at: string;
  updated_at: string;
};
